export enum EmailUpdatedSteps {
  Welcome = 0,
  LinkGoogleAccount = 1,
  Confirm = 2,
  Done = 3,
}
